import PartialPaymentsBulkUpdateModal from './PartialPaymentsBulkUpdateModal';

export default PartialPaymentsBulkUpdateModal;
